import { createColumnHelper } from '@tanstack/react-table'
import { useDispatch, useSelector } from 'react-redux'
import { selectTranslations } from '../../../services/i18n/i18nSlice'
import { useEffect, useRef, useState } from 'react'

import '../UserTable.css'
import { usePagination } from '../../../components/Table/usePagination'
import { useSorting } from '../../../components/Table/useSorting'
import { Table } from '../../../components/Table/Table'

import IndeterminateCheckbox from '../../../components/Table/Checkbox'
import { fetchGetFilteredUserExam } from '../../ExamScreen/ExamApi'
import { USER_EXAM_STATUS } from '../../../config/constants'
import { Link } from 'react-router-dom'


export default function UserExams(props) {

    const t = useSelector(selectTranslations)
    const dispatch = useDispatch()

    const [examsData, setExamsData] = useState([])
    
    const columnHelper = createColumnHelper()
    const [rowSelection, setRowSelection] = useState({})

    const [count, setCount] = useState(0);
    const [loadingData, setLoadingData] = useState(false);
    const [searchFilter, setSearchFilter] = useState("")
    const tableRef = useRef()

    // Make some columns!
    const defaultColumns = [
        {
            id: 'select',
            header: ({ table }) => (
            <IndeterminateCheckbox
                {...{
                checked: table.getIsAllRowsSelected(),
                indeterminate: table.getIsSomeRowsSelected(),
                onChange: table.getToggleAllRowsSelectedHandler(),
                }}
            />
            ),
            cell: ({ row }) => (
            <div className="px-1">
                <IndeterminateCheckbox
                {...{
                    checked: row.getIsSelected(),
                    disabled: !row.getCanSelect(),
                    indeterminate: row.getIsSomeSelected(),
                    onChange: row.getToggleSelectedHandler(),
                }}
                />
            </div>
            ),
        },
    // Display Column
        columnHelper.accessor('user_exam_id', {
            cell: group => <span style={{fontSize:'8px'}}>{group.getValue()}</span>,
            header: () => <span>ID</span>
        }),
        columnHelper.accessor('exam_title', {
            cell: group => group.getValue(),
            header: () => <span>Nome Prova</span>
        }),
        columnHelper.accessor('total_score', {
            cell:  (row) => row.getValue(),
            header: () => <span>Punteggio</span>
        }),
        columnHelper.accessor('state', {
            cell: (row) => (
                <>
                {console.log(row)}
                {!row?.row?.original?.deleted ?
                    <span className='status_label' style={{color:`${USER_EXAM_STATUS[row.getValue()]?.color}`, background: `${USER_EXAM_STATUS[row.getValue()]?.background}`}}>{USER_EXAM_STATUS[row.getValue()]?.text}</span> 
                :
                    <span className='status_label' style={{color:`${USER_EXAM_STATUS['deleted']?.color}`, background: `${USER_EXAM_STATUS['deleted']?.background}`}}>{USER_EXAM_STATUS['deleted']?.text}</span> 
                }
                </>
            ),
            header: () => <span>Nome Prova</span>
        }),
        columnHelper.accessor('start_date', {
            cell:  (row) => new Date(row.getValue())?.toLocaleString(),
            header: () => <span>Data inizio</span>
        }),
        columnHelper.accessor('end_date', {
            cell:  (row) => new Date(row.getValue())?.toLocaleString(),
            header: () => <span>Data fine</span>
        }),
        columnHelper.accessor('exam_id', {
            cell:  ({row}) => <div><Link target="_blank" to={`/exams/detailed_user_exam/${row.original.exam_id}/${row.original.user_exam_id}`}><button className='secondary'>Apri</button></Link></div>,
            header: () => <span>Azioni</span>
        }),
    ]

    const { limit, onPaginationChange, skip, pagination } = usePagination();

    const { sorting, onSortingChange, field, order } = useSorting();

    const pageCount = Math.round(count / limit) +1;

    const loadUserExams = async () => {
        let response = await fetchGetFilteredUserExam({
            user_id: props.userId,
            limit: 30
        })
        if(response.success){
            setExamsData(response?.data?.user_exams)
        }
    }

    useEffect(()=>{
        if(props?.userId)
            loadUserExams()
    },[props?.userId])

    return (
        <div>
            <div className='table_container'>
                <div className=''>
                    <div id='userSearchBar' className='reduced_table'>
                        <input type='text' placeholder={t.groups.search_group} value={searchFilter} onChange={(e)=>setSearchFilter(e.target.value)} />
                    </div>                
                </div>
                <Table
                    ref={tableRef}
                    cols={defaultColumns}
                    data={examsData || []}
                    loading={loadingData}
                    onPaginationChange={onPaginationChange}
                    onSortingChange={onSortingChange}
                    pageCount={pageCount}
                    pagination={pagination}
                    sorting={sorting}
                    enableRowSelection={true} 
                    autoResetSelectedRows={true}
                    autoResetPageIndex={true}
                    onRowSelectionChange={setRowSelection}
                    rowSelection={rowSelection}
                    getRowId={(row)=>row.group_id}
                    manualPagination={false}
                    globalFilter={searchFilter}
                    onGlobalFilterChange={setSearchFilter}
                />
            </div>
            
        </div>
        
    );
}

